import { createFileRoute } from '@tanstack/react-router';

import { clearCacheForLogout } from '../../components/shared/utilities/appUtilities';

export const Route = createFileRoute('/_authenticated/logout')({
  beforeLoad: async ({ context }) => {
    const { auth0, apolloClient } = context;
    const clientId = import.meta.env.REACT_APP_AUTH0_CLIENT_ID;

    // clear apollo/session cache before logging out
    await clearCacheForLogout(apolloClient);

    // perform logout with appropriate app redirect (if populated);
    await auth0.logout({
      clientId,
      logoutParams: {
        returnTo: `${import.meta.env.REACT_APP_AUTH0_CALLBACK}/login`,
      },
    });
  },
});
